module.exports = __webpack_public_path__ + "img/bingo_ball-17.e761a9c9.png";